<template>
  <div class="hospitalManage column-me">
    <div class="card-div column-me flex1">
      <div class="row-me row-center">
        <div class="width180">
          <el-input placeholder="医院名称" style="width: 100%;" clearable v-model="name"></el-input>
        </div>
        <div class="width180 margin-left20">
          <el-input placeholder="医院编码" style="width: 100%;" clearable v-model="code"></el-input>
        </div>
        <div class="width180 margin-left20">
          <el-select v-model="selectHouse" placeholder="所在库房" style="width: 100%;" filterable clearable>
            <el-option v-for="item in houseArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="width180 margin-left20">
          <el-select v-model="selectStatus" placeholder="状态" style="width: 100%;" filterable clearable>
            <el-option v-for="item in [{id:1,name:'正常'},{id:0,name:'关闭'}]" :key="item.id"
                       :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="btn-blue width100 btn-height40 margin-left20" @click="clickSearch">
          <el-icon>
            <search/>
          </el-icon>
          搜索
        </div>
        <div class="btn-blank width100 btn-height40 margin-left20" @click="clickClear">清空</div>
        <div class="flex1"></div>
        <div class="btn-blank width100 btn-height40 margin-left20" @click="clickExport">导出</div>
        <div class="btn-blue width100 btn-height40 margin-left20" @click="clickAdd" v-if="canOperate">新增</div>
      </div>
      <div class="column-me margin-top20">
        <div class="flex1">
          <el-table :data="tableData" border header-cell-class-name="table-header-style"
                    cell-class-name="table-cell-style">
            <el-table-column prop="no" label="医院编码" align="center"></el-table-column>
            <el-table-column prop="name" label="医院名称" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="appId" label="接口APPID" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="appSecret" label="接口密钥" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="callbackUrl" label="回传地址" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="programmeName" label="药价方案" align="center"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="pharmacyName" label="库房" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="contact" label="联系人" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="mobile" label="联系电话" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="email" label="电子邮箱" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column label="状态" align="center">
              <template #default="scope">
                {{ scope.row.enable ? '正常' : '关闭' }}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="120" v-if="canOperate">
              <template v-slot="scope">
                <div class="row-me center-all">
                  <div class="blue-text" @click="clickEdit(scope.row)">修改</div>
                  <!--                  <div class="blue-text margin-left30" @click="clickStatus(scope.row)" v-if="scope.row.enable">关闭-->
                  <!--                  </div>-->
                  <!--                  <div class="blue-text margin-left30" @click="clickStatus(scope.row)" v-else>正常</div>-->
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="margin-top20">
          <el-pagination background @current-change="handleCurrentChange" :current-page.sync="pageNo"
                         layout="total, prev, pager, next" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 新增医院 -->
    <el-dialog :title="addTitle" v-model="visibleHospital" width="1000px" top="20vh" :destroy-on-close="true">
      <editHospital :id='editId'></editHospital>
    </el-dialog>
  </div>
</template>

<script>
import editHospital from './editHospital.vue'

export default {
  components: {
    editHospital
  },
  data() {
    return {
      name: '',
      code: '',
      selectStatus: '',
      tableData: [],
      pageNo: 1,
      total: 0,
      visibleHospital: false,
      addTitle: '',
      editId: '',
      selectHouse: '',
      houseArray: [],
      canOperate: false,//是否可操作
    }
  },
  // html加载完成之前
  created() {
    this.$getMenuOperateAuth(this.$route.path).then(res => {
      this.canOperate = res.data
    })
    this.getHouseArray()
    this.clickSearch()
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    //查询
    clickSearch() {
      this.pageNo = 1
      this.getData()
    },
    //清空
    clickClear() {
      this.code = ''
      this.name = ''
      this.selectHouse = ''
      this.selectStatus = ''
      this.clickSearch()
    },
    //新增
    clickAdd() {
      this.editId = ''
      this.addTitle = '新增医院'
      this.visibleHospital = true
      this.bus.$off('addHospital')
      this.bus.$on('addHospital', res => {
        this.visibleHospital = false
        if (res === 'refresh') {
          this.pageNo = 1
          this.getData()
        }
      })
    },
    //修改
    clickEdit(item) {
      this.editId = item.id
      this.addTitle = '修改医院'
      this.visibleHospital = true
      this.bus.$off('addHospital')
      this.bus.$on('addHospital', res => {
        this.visibleHospital = false
        if (res === 'refresh') {
          this.getData()
        }
      })
    },
    //导出
    clickExport() {
      let token = sessionStorage.getItem('token')
      let param = {
        no: this.code,
        name: this.name,
        enable: this.selectStatus === '' ? '' : this.selectStatus === 1,
        pageNumber: this.pageNo,
        token: token,
      }
      let url = this.$baseUrl + '/admin/hospital/hospitalExport?' + this.$method.getParamsString(param)
      window.open(url)
    },
    //正常关闭
    clickStatus(item) {
      this.$confirm("您确定要操作吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postFormRequest('/admin/hospital/enable', {
          id: item.id,
          enable: !item.enable,
        }).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.getData()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //页数改变
    handleCurrentChange(pageNo) {
      this.pageNo = pageNo
      this.getData()
    },
    //获取数据
    getData() {
      this.$getRequest('/admin/hospital/page', {
        no: this.code,
        name: this.name,
        pharmacyId: this.selectHouse,
        enable: this.selectStatus === '' ? '' : this.selectStatus === 1,
        pageNumber: this.pageNo,
      }).then((res) => {
        if (res) {
          this.total = res.data.totalRow
          this.tableData = res.data.list
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取库房
    getHouseArray() {
      this.$getRequest('/admin/pharmacy/listAll', {}).then((res) => {
        if (res) {
          this.houseArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
}
</script>

<style lang="scss" scoped>
.hospitalManage {
  height: 100%;

  .card-div {
    margin: 20px;
    background: #FFFFFF;
    box-shadow: 0 0 5px #F3F3F3;
    border-radius: 3px;
    padding: 20px;
    overflow: auto;
  }
}
</style>
